module.exports = __webpack_public_path__ + "static/img/depot_upgrade.f6bf88e2.png";